import React, { useState } from "react";
// import Logo from "../../assets/logo/logo.png";
import Logo from "../../assets/logo/logo.png";
import { routesConfig } from "../../configs/routes";
import { NavLink } from "react-router-dom";
import { Icons } from "../../assets/icons";
const TopNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className="px-4 py-1 flex justify-between items-center shadow-md relative bg-white">
      <div className="flex gap-6 items-center">
        {/* Logo */}
        <div>
          <NavLink
            data-gtm-id="item-26"
            to="/"
            aria-label="Lilly ExploR&D Home"
            className="flex gap-2 items-center mr-4"
          >
            <img
              src={Logo}
              alt=""
              className="h-10 py-[3px]"
              // className="h-10 py-[2px]"
            />
            <div
              data-gtm-id="item-1"
              className="text-[18px] font-bold text-body-text-lilly_red mt-[2px]"
              style={{ fontFamily: "Roboto, sans-serif" }}
            >
              ExploR&D
            </div>
          </NavLink>
        </div>

        {/* Navbar Links (hidden on small screens, shown on larger screens) */}
        <div className="hidden md:flex gap-8">
          {routesConfig.map(
            (menu) =>
              menu.name && (
                <NavLink
                  data-gtm-id="item-26"
                  className={({ isActive }) =>
                    isActive
                      ? "relative text-base text-navbar-lilly_red tracking-tight after:content-[''] after:absolute after:bottom-[-0.8em] after:left-0 after:w-full after:h-[6px] after:bg-navbar-lilly_red after:z-10"
                      : "text-base font-normal tracking-tight hover:text-navbar-lilly_red"
                  }
                  to={menu.path}
                  key={menu.path}
                >
                  {menu.name}
                </NavLink>
              ),
          )}
        </div>
      </div>
      <div className="">
        <button
          className="md:hidden block focus:outline-none"
          aria-label="hamburger icon"
          onClick={toggleMenu}
        >
          {isOpen ? <Icons.Close /> : <Icons.Menu />}
        </button>
      </div>

      {/* Mobile Menu (visible on small screens) */}
      <div
        className={`md:hidden absolute top-[calc(100%)] left-0 w-full bg-white shadow-lg z-10 overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? "max-h-[500px]" : "max-h-0"
        }`}
      >
        <div className="flex flex-col gap-2 p-4">
          {routesConfig.map(
            (menu) =>
              menu.name && (
                <NavLink
                  data-gtm-id="item-27"
                  className={({ isActive }) =>
                    isActive
                      ? "relative text-base text-navbar-lilly_red tracking-tight"
                      : "text-base font-normal tracking-tight"
                  }
                  to={menu.path}
                  key={menu.path}
                  onClick={toggleMenu} // Close menu on click
                >
                  {menu.name}
                </NavLink>
              ),
          )}
        </div>
      </div>
    </div>
  );
};

export default TopNavbar;
